// Build touch: no functional change (republish trigger, 04/09/2026).
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
// AUDIENCE-SEPARATION (Phase 4 build-wall): main.tsx remains the DEFAULT internal entry. index.html
// still points at /src/main.tsx, so the default build produces dist/index.html served by the live
// (Lovable) pipeline exactly as today. It now mounts AppInternal (the fragment-composed successor to
// the original monolithic App), which composes every surface including the internal-only research
// tree. The adviser/public entries live under src/entries/*.
import App from "@/app/AppInternal";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import "./index.css";
import "@fontsource/sora/400.css";
import "@fontsource/sora/600.css";
import "@fontsource/sora/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ThemeProvider>
);
